import React, { useState, useEffect } from 'react'
import styled from 'styled-components';
import Avatar from '../common/Avatar';
import Logo from '../../assets/images/logo.svg'
import useAuth from '../../hooks/useAuth';
import { User, LogOut, ChevronDown } from 'react-feather'
import {NavLink,useNavigate} from 'react-router-dom';



// Lógica de renderización del dropdown de usuario
function DropDownMenu({ dropDown, closeMenu, user, logout, navigate }) {
    if (dropDown) {
        return (
            <DropContent>
                <div>
                    <span><span>Rol: </span>{user.rol}</span>
                </div>
                <DropOption onClick={() => {navigate("../profile");closeMenu()}}><User />Editar perfil</DropOption>
                <DropOption onClick={() => logout()}><LogOut />Cerrar sesión</DropOption>
            </DropContent>
        )
    }
}


const Header = ({route,customRoutes}) => {
    const { user, logout } = useAuth();
    const [dropDown, setDropDown] = useState(false);
    let navigate = useNavigate();

    //Manipuladores
    const handleToggleMenu = (e) => {
        setDropDown(e.target.checked);
    }

    const closeMenu = () => {
        setDropDown(false);
        document.getElementById("boton").checked = false;
    }

    return (
        <Wrapper customRoutes={customRoutes} route={route}>
            <Navigation>
                <Brand src={Logo}></Brand>
                {user?.rol == "estudiante" &&
                    <Links onClick={()=>{closeMenu()}}>
                        <ul>
                            <li><NavLink to='/home' className='link'>Contenido</NavLink></li>
                            <li><NavLink to='/profile' className='link'>Perfil</NavLink></li>
                        </ul>
                    </Links>
                }
                {user?.rol == "docente" &&
                    <Links onClick={()=>{closeMenu()}}>
                        <ul>
                            <li><NavLink to='/homeDocente' className='link'>Cursos</NavLink></li>
                            <li><NavLink to='/profile' className='link'>Perfil</NavLink></li>
                        </ul>
                    </Links>
                }
                <UserDropdown>
                    <DropButton>
                        <span>{user.nombre}</span>
                        <Avatar width='40px' src={user.avatar}></Avatar>
                        <Button type='checkbox' id='boton' onChange={handleToggleMenu}></Button>
                        <Label htmlFor='boton'><ChevronDown /></Label>
                    </DropButton>
                    <DropDownMenu dropDown={dropDown} user={user} logout={logout} navigate={navigate} closeMenu={closeMenu}></DropDownMenu>
                </UserDropdown>
            </Navigation>
        </Wrapper>
    )
}

export default Header;

const Wrapper = styled.header`
    ${({customRoutes, route}) => customRoutes?.includes(route) &&`
        background-color:var(--color-morado-oscuro);
        position:fixed;
        top:0;
        width: 100%;
        z-index:1000;
  `}
`;

const Navigation = styled.nav`
    display: flex;
    flex-direction:row;
    justify-content: space-between;
    align-items:center;
    max-height: 48px;
    padding: 8px 32px;
    color: var(--color-blanco);
    font-weight: 700;
`;

const Brand = styled.img`
    height:30px;
`;

const Links = styled.div`

    .active{
        border-bottom:2px solid var(--color-rosa);
    }

    ul{
        display:flex;
        flex-direction: row;
        list-style:none;
    }
    ul li {
        margin: 0px 32px;
        cursor: pointer;
        transition: all 0.3s;
    }

    .link{
        color:var(--color-morado-);
        text-decoration:none;
        :hover{
            border-bottom:2px solid var(--color-rosa);
        }
    }


`;

const DropContent = styled.div`
    display: block;
    position: absolute;
    right:0px;
    margin: 8px 32px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    background-color:var(--color-blanco);
    border-radius: 5px;
    z-index: 1;
    div{
        display:flex;
        flex-direction:column;
        padding: 8px;
        color: var(--color-negro);
        border-bottom: 1px solid var(--color-gris-claro);
        
        span{
            font-weight: 300;
            span{
                font-weight: 700;
            }
        }
    }
`;

const UserDropdown = styled.div`
    display: inline-block;
    width:30%;
`;

const DropButton = styled.div`
    display: flex;
    justify-content:right;
    align-items:center;
    span{
        margin-right: 16px;
    }
    
`;

const Button = styled.input`
    width:0;
    &:checked + label {
        transform: rotate(180deg);
    }
`;

const Label = styled.label`
    margin-left:8px;
    cursor:pointer;
    user-select:none;
    transition: all 0.3s; 
`;

const DropOption = styled.a`
    padding: 12px 16px;
    border-radius:5px;
    color: var(--color-negro);
    display:flex;
    align-items:center;
    justify-content: left;
    cursor: pointer;

    &:hover {
        background-color: var(--color-gris-claro);
    }
    
    svg{
        margin-right: 8px;
        width:24px;
    }

    &:nth-child(3){
        color: var(--color-error)
    }
`;

